/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
export default {
    log(...args: any) {
        if (process.env.NODE_ENV === "development") {
            console.log(...args);
        }
    },
    debug(...args: any) {
        if (process.env.NODE_ENV === "development") {
            console.debug(...args);
        }
    },

    warn(msg: any) {
        console.warn(msg);
    },

    error(...args: any) {
        console.error(...args);
    },

    info(msg: any) {
        console.info(msg);
    },

    trace(...args: any) {
        if (process.env.NODE_ENV === "development") {
            console.trace(...args);
        }
    },

    table(...args: any) {
        if (process.env.NODE_ENV === "development") {
            console.table(...args);
        }
    },
};
